import { UiImageModel } from "../../models";

import { mock$AssetModel } from "./mock-asset";

export function mockUiImageModel({
    id = "image-1234",
    type = "uiImage",
    locale = "en",
    content = mockUiImageModelContent()
}: Partial<UiImageModel> = {}): UiImageModel {
    return {
        id,
        type,
        locale,
        content
    };
}

export type UiImageModelContent = UiImageModel["content"];

export function mockUiImageModelContent({
    image = mock$AssetModel()
}: Partial<UiImageModelContent> = {}): UiImageModelContent {
    return {
        image
    };
}
